import createIcon from '../../createIcon';

/**
 * @component @name HelpCenter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMi4wMSAxOEMxMS4zMSAxOCAxMC43NSAxNy40NCAxMC43NSAxNi43NEMxMC43NSAxNi4wMyAxMS4zMSAxNS40OSAxMi4wMSAxNS40OUMxMi43MiAxNS40OSAxMy4yNiAxNi4wMyAxMy4yNiAxNi43NEMxMy4yNSAxNy40MyAxMi43MiAxOCAxMi4wMSAxOFpNMTUuMDIgMTAuNkMxNC4yNiAxMS43MSAxMy41NCAxMi4wNiAxMy4xNSAxMi43N0MxMi45OSAxMy4wNiAxMi45MyAxMy4yNSAxMi45MyAxNC4xOEgxMS4xMUMxMS4xMSAxMy42OSAxMS4wMyAxMi44OSAxMS40MiAxMi4yQzExLjkxIDExLjMzIDEyLjg0IDEwLjgxIDEzLjM4IDEwLjA0QzEzLjk1IDkuMjMgMTMuNjMgNy43MSAxMi4wMSA3LjcxQzEwLjk1IDcuNzEgMTAuNDMgOC41MSAxMC4yMSA5LjE5TDguNTYgOC40OUM5LjAxIDcuMTUgMTAuMjIgNiAxMS45OSA2QzEzLjQ3IDYgMTQuNDggNi42NyAxNSA3LjUyQzE1LjQ0IDguMjQgMTUuNyA5LjU5IDE1LjAyIDEwLjZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HelpCenter = createIcon('HelpCenter', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12.01 18C11.31 18 10.75 17.44 10.75 16.74C10.75 16.03 11.31 15.49 12.01 15.49C12.72 15.49 13.26 16.03 13.26 16.74C13.25 17.43 12.72 18 12.01 18ZM15.02 10.6C14.26 11.71 13.54 12.06 13.15 12.77C12.99 13.06 12.93 13.25 12.93 14.18H11.11C11.11 13.69 11.03 12.89 11.42 12.2C11.91 11.33 12.84 10.81 13.38 10.04C13.95 9.23 13.63 7.71 12.01 7.71C10.95 7.71 10.43 8.51 10.21 9.19L8.56 8.49C9.01 7.15 10.22 6 11.99 6C13.47 6 14.48 6.67 15 7.52C15.44 8.24 15.7 9.59 15.02 10.6Z',
      key: 'a8xyl6',
    },
  ],
]);

export default HelpCenter;
